<template>
    <!-- Modal Overlay -->
    <Transition name="modal-fade">
        <div v-if="isdisplay" class="cf-overlay" @click.self="close">
            <Transition name="modal-slide">
                <div v-if="isdisplay" class="cf-dialog cf-dialog--xxl" @click.stop>

                    <!-- ========== HEADER ========== -->
                    <div class="cf-modal-head cf-dialog-head">
                        <div class="cf-modal-head__main">
                            <span class="cf-modal-head__icon"><i class="ri-file-list-3-line"></i></span>
                            <div>
                                <h4 class="cf-dialog-title">{{ titlemodal }}</h4>
                                <p class="cf-modal-head__sub">{{ getDocumentTypeLabel() }}</p>
                            </div>
                        </div>
                        <button @click="close" type="button" class="cf-dialog-close" aria-label="Fermer"><i class="ri-close-line"></i></button>
                    </div>

                    <!-- ========== TOOLBAR ========== -->
                    <div class="cf-dialog-toolbar">
                        <div class="cf-toolbar-row">
                            <div class="search-wrap">
                                <i class="ri-search-line search-icon"></i>
                                <input v-model="searchword" type="search" class="search-input"
                                       placeholder="Rechercher par n° document, magasin, observation...">
                                <button v-if="searchword" @click="searchword = ''" class="search-clear" aria-label="Effacer"><i class="ri-close-line"></i></button>
                            </div>
                            <button @click="btnajouter" class="ti-btn ti-btn-primary-full">
                                <i class="ri-add-line align-middle"></i>
                                <span class="hidden sm:inline">&nbsp;Nouveau mouvement</span>
                                <span class="sm:hidden">&nbsp;Ajouter</span>
                            </button>
                        </div>
                        <div class="cf-toolbar-meta">
                            <div class="cf-period">
                                <button v-for="period in periodOptions" :key="period.value"
                                        @click="handlePeriodChange(period.value)"
                                        class="cf-period-btn" :class="{ 'cf-period-btn--active': indexbutton === period.value }">
                                    {{ period.label }}
                                </button>
                            </div>
                            <div class="cf-perpage">
                                <label>Afficher</label>
                                <div class="cf-select-wrap">
                                    <select v-model="DefaultperPage" class="cf-select--sm">
                                        <option v-for="option in perPageOptions" :key="option" :value="option">{{ option }}</option>
                                    </select>
                                    <i class="ri-arrow-down-s-line cf-select-arrow"></i>
                                </div>
                                <span class="cf-count"><b>{{ filteredData.length }}</b> résultat{{ filteredData.length > 1 ? 's' : '' }}</span>
                            </div>
                        </div>
                    </div>

                    <!-- ========== BODY ========== -->
                    <div class="cf-dialog-body cf-dialog-body--flush">
                        <!-- Desktop table -->
                        <div class="table-scroll-wrap doc-scroll hidden lg:block">
                            <table class="doc-table">
                                <thead>
                                    <tr>
                                        <th class="th" style="width:4rem">N°</th>
                                        <th class="th">N° Document</th>
                                        <th class="th">Magasin/Entrepôt</th>
                                        <th v-if="typedoc === 'mvt_transfert'" class="th">Vers Magasin</th>
                                        <th class="th">Observation</th>
                                        <th class="th">N° Bon</th>
                                        <th class="th">Créé le</th>
                                        <th class="th">Créé par</th>
                                        <th class="th th--center" style="width:9rem">Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <template v-if="paginatedData.length">
                                        <tr v-for="(item, index) in paginatedData" :key="item.pid" class="table-row">
                                            <td class="td row-number">{{ (page - 1) * DefaultperPage + index + 1 }}</td>
                                            <td class="td"><span class="cf-docnum">{{ item.numdoc }}</span></td>
                                            <td class="td cf-strong">{{ item.magname }}</td>
                                            <td v-if="typedoc === 'mvt_transfert'" class="td">{{ item.vmagname }}</td>
                                            <td class="td"><span class="cf-ellip" :title="item.mobservations">{{ item.mobservations || '-' }}</span></td>
                                            <td class="td">{{ item.numbon || '-' }}</td>
                                            <td class="td">{{ formatDate(item.creerler) }}</td>
                                            <td class="td">{{ item.saisiepar }}</td>
                                            <td class="td td--center">
                                                <div class="cf-actions">
                                                    <button v-if="item.nbp > 0" @click="btnopen(item)" class="cf-iconbtn cf-iconbtn--primary" title="Ouvrir"><i class="ri-eye-line"></i></button>
                                                    <button v-if="item.nbp > 0" @click="btnimpression(item)" class="cf-iconbtn cf-iconbtn--success" title="Imprimer"><i class="ri-printer-line"></i></button>
                                                    <button v-if="item.nbp === 0" @click="btnmodifier(item)" class="cf-iconbtn cf-iconbtn--info" title="Modifier"><i class="ri-edit-line"></i></button>
                                                    <button v-if="item.nbp === 0" @click="btnsuppression(item)" class="cf-iconbtn cf-iconbtn--danger" title="Supprimer"><i class="ri-delete-bin-line"></i></button>
                                                </div>
                                            </td>
                                        </tr>
                                    </template>
                                    <tr v-else>
                                        <td :colspan="typedoc === 'mvt_transfert' ? 9 : 8" class="td">
                                            <div class="empty-state">
                                                <div class="empty-state__icon"><i class="ri-file-list-3-line"></i></div>
                                                <p class="empty-state__title">Aucun document trouvé</p>
                                                <p class="empty-state__sub">{{ searchword ? 'Essayez de modifier vos critères de recherche' : 'Commencez par créer un nouveau document' }}</p>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <!-- Mobile cards -->
                        <div class="lg:hidden doc-scroll cf-cards">
                            <template v-if="paginatedData.length">
                                <div v-for="(item, index) in paginatedData" :key="item.pid" class="cf-card">
                                    <div class="cf-card-head">
                                        <div class="cf-card-headmain">
                                            <span class="cf-card-index">{{ (page - 1) * DefaultperPage + index + 1 }}</span>
                                            <span class="cf-docnum">{{ item.numdoc }}</span>
                                        </div>
                                        <span class="cf-badge" :class="item.nbp === 0 ? 'cf-badge--ok' : 'cf-badge--muted'">{{ item.nbp === 0 ? 'Modifiable' : 'Validé' }}</span>
                                    </div>
                                    <div class="cf-card-body">
                                        <div class="cf-card-grid">
                                            <div><p class="cf-card-lbl">Magasin</p><p class="cf-card-val">{{ item.magname }}</p></div>
                                            <div v-if="typedoc === 'mvt_transfert'"><p class="cf-card-lbl">Vers</p><p class="cf-card-val">{{ item.vmagname }}</p></div>
                                            <div><p class="cf-card-lbl">N° Bon</p><p class="cf-card-val">{{ item.numbon || '-' }}</p></div>
                                            <div><p class="cf-card-lbl">Date</p><p class="cf-card-val">{{ formatDate(item.creerler) }}</p></div>
                                        </div>
                                        <div v-if="item.mobservations" class="cf-card-obs">
                                            <p class="cf-card-lbl">Observation</p>
                                            <p class="cf-card-val cf-card-val--muted">{{ item.mobservations }}</p>
                                        </div>
                                    </div>
                                    <div class="cf-card-foot">
                                        <span class="cf-card-by">Par {{ item.saisiepar }}</span>
                                        <div class="cf-actions">
                                            <button v-if="item.nbp > 0" @click="btnopen(item)" class="cf-iconbtn cf-iconbtn--primary" title="Ouvrir"><i class="ri-eye-line"></i></button>
                                            <button v-if="item.nbp > 0" @click="btnimpression(item)" class="cf-iconbtn cf-iconbtn--success" title="Imprimer"><i class="ri-printer-line"></i></button>
                                            <button v-if="item.nbp === 0" @click="btnmodifier(item)" class="cf-iconbtn cf-iconbtn--info" title="Modifier"><i class="ri-edit-line"></i></button>
                                            <button v-if="item.nbp === 0" @click="btnsuppression(item)" class="cf-iconbtn cf-iconbtn--danger" title="Supprimer"><i class="ri-delete-bin-line"></i></button>
                                        </div>
                                    </div>
                                </div>
                            </template>
                            <div v-else class="empty-state">
                                <div class="empty-state__icon"><i class="ri-file-list-3-line"></i></div>
                                <p class="empty-state__title">Aucun document trouvé</p>
                            </div>
                        </div>
                    </div>

                    <!-- ========== FOOTER ========== -->
                    <div class="cf-dialog-foot cf-dialog-foot--split">
                        <p class="cf-foot-info">{{ paginationStart }}–{{ paginationEnd }} sur {{ filteredData.length }} résultats</p>
                        <div class="pagination" v-if="pages.length > 1">
                            <button class="page-btn page-btn--nav" @click="page--" :disabled="page === 1"><i class="ri-arrow-left-s-line"></i></button>
                            <template v-for="pageNum in displayedPages" :key="pageNum">
                                <span v-if="pageNum === '...'" class="cf-ellipsis">…</span>
                                <button v-else class="page-btn" :class="{ 'page-btn--active': page === pageNum }" @click="page = pageNum">{{ pageNum }}</button>
                            </template>
                            <button class="page-btn page-btn--nav" @click="page++" :disabled="page === pages.length || pages.length === 0"><i class="ri-arrow-right-s-line"></i></button>
                        </div>
                    </div>

                </div>
            </Transition>
        </div>
    </Transition>

    <!-- Child Components -->
    <modalopenform ref="modalopenform" />
    <modalform ref="modalform" @closed="load" />
    <modalimpressiondoc ref="modalimpressiondoc" />
    <modalformsuppression @closed="load" ref="modalformsuppression" />
</template>

<script>
    /* eslint-disable */
    const axios = require('axios');
    import { randomString } from "@/allfunction";
    import * as JwtService from "@/common/jwt.service";

    import modalopenform from "@/components/views/pages/stock/mvtstock/modal_openform";
    import modalform from "@/components/views/pages/stock/mvtstock/sansvalidation/form";
    import modalformsuppression from "@/components/views/pages/stock/mvtstock/sansvalidation/formsuppression";
    import modalimpressiondoc from "@/components/views/pages/stock/mvtstock/modal_etatdocstock";

    export default {
        /* eslint-disable */
        name: "StockDocumentManager",

        components: {
            modalform,
            modalformsuppression,
            modalimpressiondoc,
            modalopenform
        },

        data() {
            return {
                isdisplay: false,
                titlemodal: "",
                typedoc: "",

                // Data
                datatable: [],
                otherdata: [],
                selectedItem: null,

                // Search and filters
                searchword: "",
                indexbutton: "1d",
                showMobileActionSheet: false,

                // Pagination
                page: 1,
                DefaultperPage: 50,
                perPageOptions: [10, 25, 50, 100, 200, 250, 300],

                // Period options
                periodOptions: [
                    { label: '1J', value: '1d' },
                    { label: '3J', value: '3d' },
                    { label: '1S', value: '7d' },
                    { label: '1M', value: '1M' },
                    { label: '3M', value: '3M' },
                    { label: '6M', value: '6M' },
                    { label: '1A', value: '12M' },
                ],
            };
        },

        computed: {
            filteredData() {
                let data = [...this.datatable];

                if (this.searchword) {
                    const query = this.searchword.toLowerCase().trim();
                    data = data.filter(item =>
                        item.numdoc?.toString().toLowerCase().includes(query) ||
                        item.magname?.toString().toLowerCase().includes(query) ||
                        item.mobservations?.toString().toLowerCase().includes(query) ||
                        item.numbon?.toString().toLowerCase().includes(query)
                    );
                }

                return data;
            },

            paginatedData() {
                const start = (this.page - 1) * this.DefaultperPage;
                return this.filteredData.slice(start, start + this.DefaultperPage);
            },

            pages() {
                const numberOfPages = Math.ceil(this.filteredData.length / this.DefaultperPage);
                return Array.from({ length: numberOfPages }, (_, i) => i + 1);
            },

            displayedPages() {
                const total = this.pages.length;
                const current = this.page;

                if (total <= 7) {
                    return this.pages;
                }

                const pages = [];
                if (current <= 3) {
                    pages.push(1, 2, 3, 4, '...', total);
                } else if (current >= total - 2) {
                    pages.push(1, '...', total - 3, total - 2, total - 1, total);
                } else {
                    pages.push(1, '...', current - 1, current, current + 1, '...', total);
                }

                return pages;
            },

            paginationStart() {
                return this.filteredData.length === 0 ? 0 : (this.page - 1) * this.DefaultperPage + 1;
            },

            paginationEnd() {
                return Math.min(this.page * this.DefaultperPage, this.filteredData.length);
            },
        },

        watch: {
            searchword() {
                this.page = 1;
            },
            DefaultperPage() {
                this.page = 1;
            },
            page() {
                // Scroll to top when page changes
                const tableContainer = this.$el?.querySelector('.overflow-auto');
                if (tableContainer) {
                    tableContainer.scrollTop = 0;
                }
            },
        },

        methods: {
            show(titlemodal, typedoc) {
                this.titlemodal = titlemodal;
                this.typedoc = typedoc;
                this.resetState();
                this.loadreturnotherdata();
                this.load();
                this.isdisplay = true;
                document.body.style.overflow = 'hidden';
            },

            close() {
                this.isdisplay = false;
                document.body.style.overflow = '';
                this.closeMobileActions();
            },

            resetState() {
                this.searchword = "";
                this.indexbutton = "1d";
                this.page = 1;
                this.datatable = [];
                this.selectedItem = null;
            },

            openMobileActions(item) {
                this.selectedItem = item;
                this.showMobileActionSheet = true;
            },

            closeMobileActions() {
                this.showMobileActionSheet = false;
                this.selectedItem = null;
            },

            async load() {
                try {
                    this.$store.dispatch('lancerchargement', true);
                    const url = `${process.env.VUE_APP_API_URL}/jkebfiuebffeznfoieznofibeubqsyudfyegl745874stock771714dfe/stock/sansvalidation/all/${this.typedoc}/${this.indexbutton}/${this.$store.state.appsociete}/${randomString()}`;

                    const response = await axios.get(url, {
                        headers: {
                            'X-Requested-With': 'XMLHttpRequest',
                            'Accept': 'application/json',
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${JwtService.getToken()}`,
                            'csrftoken': this.$store.state.appsociete,
                        },
                        withCredentials: true,
                    });

                    if (response.data.success) {
                        this.datatable = response.data.m || [];
                    } else {
                        this.datatable = [];
                    }
                } catch (error) {
                    console.error('Error loading data:', error);
                    this.datatable = [];
                } finally {
                    this.$store.dispatch('lancerchargement', false);
                }
            },

            async loadreturnotherdata() {
                try {
                    const url = `${process.env.VUE_APP_API_URL}/jkebfiuebffeznfoieznofibeubqsyudfyegl745874stock771714dfe/stock/othetdskd8755dsdhisd/${this.$store.state.appsociete}/${randomString()}`;

                    const response = await axios.get(url, {
                        headers: {
                            'X-Requested-With': 'XMLHttpRequest',
                            'Accept': 'application/json',
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${JwtService.getToken()}`,
                            'csrftoken': this.$store.state.appsociete,
                        },
                        withCredentials: true,
                    });

                    if (response.data.success) {
                        this.otherdata = response.data.otherdata || [];
                    }
                } catch (error) {
                    console.error('Error loading other data:', error);
                }
            },

            handlePeriodChange(period) {
                this.indexbutton = period;
                this.page = 1;
                this.load();
            },

            getDocumentTypeLabel() {
                const labels = {
                    'mvt_entree': "Mouvements d'entrée",
                    'mvt_sortie': "Mouvements de sortie",
                    'mvt_d_inventaire': "Mouvements d'inventaire",
                    'mvt_transfert': "Transferts entre magasins",
                    'depreciation': "Dépréciations de stock",
                };
                return labels[this.typedoc] || "Documents";
            },

            formatDate(dateString) {
                if (!dateString) return '-';
                try {
                    return new Intl.DateTimeFormat('fr-FR', {
                        day: '2-digit',
                        month: '2-digit',
                        year: 'numeric'
                    }).format(new Date(dateString));
                } catch {
                    return dateString;
                }
            },

            // Action methods
            btnajouter() {
                const labels = {
                    'mvt_entree': "Enregistrer un mouvement d'entrée",
                    'mvt_sortie': "Enregistrer un mouvement de sortie",
                    'mvt_d_inventaire': "Enregistrer un mouvement d'inventaire",
                    'mvt_transfert': "Enregistrer un mouvement de transfert",
                    'depreciation': "Enregistrer une dépréciation de stock",
                };

                const item = {
                    pid: '',
                    mag: null,
                    datedoc: this.$store.state.appserverdate,
                    docobservation: '',
                    docnum: '',
                    docnumother: '',
                    docpid: 0,
                    doctyp: '',
                    infodoc: {
                        infolibre: '',
                        infolibre1: '',
                        infolibre2: '',
                        infolibre3: '',
                    },
                    jsonotherdonne: {
                        tpdoc: "",
                        tredocument: this.typedoc,
                        collaborateur: null,
                        magvers: null,
                        cltfrs: null,
                        moderglt: null,
                        cdtreglement: null,
                        appliquetva: 1,
                        aib: 0,
                        adresseexpedition: {
                            infolibre: '',
                            infolibre1: '',
                            infolibre2: '',
                            infolibre3: '',
                        },
                        infodoc: {
                            infolibre: '',
                            infolibre1: '',
                            infolibre2: '',
                            infolibre3: '',
                        },
                    },
                    mtnt: {
                        docmtntaib: "0",
                        docmtntremise: "0",
                        docmtnttotalht: "0",
                        docmtnttotalttc: "0",
                        doctva: "0",
                        libaib: "AIB"
                    },
                    params: {
                        param1: null,
                        param2: null,
                        param3: null,
                        param4: null,
                    },
                    jsondoc: {}
                };

                this.$refs.modalform.show(labels[this.typedoc] || "Nouveau document", "add", this.typedoc, item, this.otherdata);
            },

            btnmodifier(item) {
                const title = `Modifier le document ${item.numdoc}`;
                this.$refs.modalform.showupdate(title, "update", this.typedoc, item, this.otherdata);
            },

            btnopen(item) {
                const title = `Document ${item.numdoc}`;
                this.$refs.modalopenform.showupdate(title, "update", this.typedoc, item, this.otherdata);
            },

            btnimpression(item) {
                this.$refs.modalimpressiondoc.show(item);
            },

            btnsuppression(item) {
                if (item.useline === 1 || item.useline === '1') {
                    this.$toast?.error("Impossible de supprimer cette ligne. Veuillez contacter votre administrateur.");
                    return;
                }

                const title = `VOULLEZ-VOUS VRAIMENT SUPPRIMER LE DOCUMENT ${item.numdoc} ?`;
                this.$refs.modalformsuppression.show(title, item, this.typedoc);
            },

            beforeUnmount() {
                document.body.style.overflow = '';
            },
        },
    };
</script>

<style scoped>
/* Charte cf-/ds- : tokens uniquement (light-only) */
.cf-overlay { position:fixed; inset:0; z-index:1000; display:flex; align-items:center; justify-content:center; padding:1rem; background:rgb(15 23 42 / 0.45); }
.cf-dialog { width:100%; background:#fff; border-radius:var(--cf-radius); box-shadow:var(--cf-shadow-md); display:flex; flex-direction:column; max-height:94vh; overflow:hidden; }
.cf-dialog--xxl { max-width:1200px; }
.cf-dialog-head { display:flex; align-items:center; justify-content:space-between; padding:1rem 1.25rem; border-bottom:1px solid var(--cf-border); flex-shrink:0; }
.cf-dialog-title { margin:0; font-size:0.95rem; font-weight:700; color:var(--cf-ink-strong); }
.cf-dialog-close { height:2rem; width:2rem; flex-shrink:0; display:inline-flex; align-items:center; justify-content:center; border-radius:var(--cf-radius-sm); border:none; background:var(--cf-surface-alt); color:var(--cf-muted); cursor:pointer; transition:all .15s; }
.cf-dialog-close:hover { background:#fee2e2; color:rgb(var(--danger)); }
.cf-dialog-toolbar { padding:0.75rem 1.25rem; border-bottom:1px solid var(--cf-border); background:var(--cf-surface); flex-shrink:0; }
.cf-dialog-body { padding:1.1rem 1.25rem; overflow-y:auto; flex:1; }
.cf-dialog-body--flush { padding:0; }
.cf-dialog-foot { display:flex; align-items:center; justify-content:flex-end; gap:0.6rem; padding:0.9rem 1.25rem; border-top:1px solid var(--cf-border); background:var(--cf-surface); flex-shrink:0; }
.cf-dialog-foot--split { justify-content:space-between; flex-wrap:wrap; gap:0.6rem; }

/* Toolbar */
.cf-toolbar-row { display:flex; gap:0.75rem; align-items:center; }
.search-wrap { position:relative; flex:1; }
.search-icon { position:absolute; left:12px; top:50%; transform:translateY(-50%); color:var(--cf-faint); }
.search-input { width:100%; padding:9px 34px; border:1px solid rgb(var(--input-border,203 213 225)); border-radius:var(--cf-radius-sm); font-size:0.82rem; color:var(--cf-ink); outline:none; transition:border-color 0.2s; }
.search-input:focus { border-color:rgb(var(--primary)); box-shadow:0 0 0 3px rgb(var(--primary) / 0.10); }
.search-clear { position:absolute; right:8px; top:50%; transform:translateY(-50%); background:none; border:none; cursor:pointer; color:var(--cf-faint); }
.cf-toolbar-meta { display:flex; align-items:center; justify-content:space-between; margin-top:0.7rem; gap:0.75rem; flex-wrap:wrap; }
.cf-period { display:inline-flex; gap:2px; background:var(--cf-surface-alt); padding:3px; border-radius:var(--cf-radius-sm); flex-wrap:wrap; }
.cf-period-btn { padding:5px 12px; font-size:0.76rem; font-weight:600; color:var(--cf-muted); background:none; border:none; border-radius:calc(var(--cf-radius-sm) - 1px); cursor:pointer; transition:all 0.15s; }
.cf-period-btn:hover { color:var(--cf-ink-strong); }
.cf-period-btn--active { background:#fff; color:rgb(var(--primary)); box-shadow:0 1px 2px rgb(15 23 42 / 0.08); }
.cf-perpage { display:flex; align-items:center; gap:0.4rem; font-size:0.8rem; color:var(--cf-muted); }
.cf-select-wrap { position:relative; }
.cf-select--sm { appearance:none; height:34px; padding:0 28px 0 10px; border:1px solid rgb(var(--input-border,203 213 225)); border-radius:var(--cf-radius-sm); background:#fff; font-size:0.8rem; color:var(--cf-ink); cursor:pointer; }
.cf-select-arrow { position:absolute; right:10px; top:50%; transform:translateY(-50%); color:var(--cf-faint); pointer-events:none; }
.cf-count b { color:var(--cf-ink-strong); }

/* Table */
.table-scroll-wrap { overflow:auto; }
.doc-scroll { max-height:56vh; }
.doc-table { width:100%; text-align:left; font-size:13px; border-collapse:collapse; min-width:720px; }
.th { position:sticky; top:0; z-index:2; padding:0.7rem 1rem; font-weight:600; font-size:0.75rem; color:var(--cf-ink); background:var(--cf-surface-alt); border-bottom:1px solid var(--cf-border); white-space:nowrap; letter-spacing:0.02em; text-align:left; }
.th--center { text-align:center; }
.table-row { border-bottom:1px solid var(--cf-surface-alt); transition:background-color 0.15s; }
.table-row:hover { background:var(--cf-surface); }
.td { padding:0.6rem 1rem; font-size:0.82rem; color:var(--cf-ink); vertical-align:middle; }
.td--center { text-align:center; }
.row-number { color:var(--cf-faint); font-size:0.75rem; font-variant-numeric:tabular-nums; }
.cf-strong { font-weight:500; color:var(--cf-ink-strong); }
.cf-docnum { display:inline-flex; align-items:center; padding:2px 9px; font-size:0.78rem; font-weight:600; color:rgb(var(--primary)); background:rgb(var(--primary) / 0.10); border-radius:var(--cf-radius-sm); }
.cf-ellip { display:inline-block; max-width:220px; overflow:hidden; text-overflow:ellipsis; white-space:nowrap; vertical-align:middle; color:var(--cf-muted); }

/* Icon action buttons */
.cf-actions { display:inline-flex; align-items:center; gap:4px; justify-content:center; }
.cf-iconbtn { height:2rem; width:2rem; display:inline-flex; align-items:center; justify-content:center; border:none; border-radius:var(--cf-radius-sm); cursor:pointer; font-size:1rem; transition:all 0.15s; background:var(--cf-surface-alt); color:var(--cf-muted); }
.cf-iconbtn--primary:hover { background:rgb(var(--primary) / 0.12); color:rgb(var(--primary)); }
.cf-iconbtn--success:hover { background:rgb(var(--success) / 0.12); color:rgb(var(--success)); }
.cf-iconbtn--info:hover { background:rgba(37,99,235,0.12); color:#2563eb; }
.cf-iconbtn--danger:hover { background:rgb(var(--danger) / 0.12); color:rgb(var(--danger)); }

/* Badges */
.cf-badge { display:inline-flex; align-items:center; padding:2px 9px; font-size:0.72rem; font-weight:600; border-radius:999px; white-space:nowrap; }
.cf-badge--ok { background:#dcfce7; color:#15803d; }
.cf-badge--muted { background:var(--cf-surface-alt); color:var(--cf-muted); }

/* Empty state */
.empty-state { padding:2.5rem 1.5rem; text-align:center; }
.empty-state__icon { font-size:40px; color:var(--cf-faint); margin-bottom:14px; }
.empty-state__title { font-size:0.95rem; font-weight:600; color:var(--cf-ink-strong); margin:0; }
.empty-state__sub { font-size:0.8rem; color:var(--cf-muted); margin:4px 0 0; }

/* Mobile cards */
.cf-cards { padding:0.75rem; display:flex; flex-direction:column; gap:0.6rem; }
.cf-card { border:1px solid var(--cf-border); border-radius:var(--cf-radius-sm); overflow:hidden; background:#fff; }
.cf-card-head { display:flex; align-items:center; justify-content:space-between; padding:0.6rem 0.85rem; background:var(--cf-surface-alt); border-bottom:1px solid var(--cf-border); }
.cf-card-headmain { display:flex; align-items:center; gap:0.5rem; min-width:0; }
.cf-card-index { flex-shrink:0; display:inline-flex; align-items:center; justify-content:center; min-width:1.5rem; height:1.5rem; padding:0 5px; font-size:0.72rem; font-weight:700; color:#fff; background:rgb(var(--primary)); border-radius:999px; }
.cf-card-body { padding:0.75rem 0.85rem; }
.cf-card-grid { display:grid; grid-template-columns:1fr 1fr; gap:0.6rem; }
.cf-card-lbl { font-size:0.68rem; text-transform:uppercase; letter-spacing:0.03em; color:var(--cf-muted); margin:0 0 2px; }
.cf-card-val { font-size:0.82rem; font-weight:500; color:var(--cf-ink-strong); margin:0; }
.cf-card-val--muted { font-weight:400; color:var(--cf-muted); }
.cf-card-obs { margin-top:0.6rem; padding-top:0.6rem; border-top:1px solid var(--cf-surface-alt); }
.cf-card-foot { display:flex; align-items:center; justify-content:space-between; padding:0.5rem 0.85rem; border-top:1px solid var(--cf-border); background:var(--cf-surface); }
.cf-card-by { font-size:0.72rem; color:var(--cf-muted); }

/* Footer / pagination */
.cf-foot-info { font-size:0.78rem; color:var(--cf-muted); margin:0; }
.pagination { display:flex; align-items:center; gap:4px; }
.cf-ellipsis { padding:0 4px; color:var(--cf-faint); }
.page-btn { min-width:30px; height:30px; padding:0 8px; border:1px solid rgb(var(--input-border,203 213 225)); border-radius:var(--cf-radius-sm); background:#fff; color:var(--cf-ink); font-size:0.78rem; font-weight:600; cursor:pointer; transition:all 0.15s; }
.page-btn:hover:not(:disabled) { border-color:rgb(var(--primary) / 0.35); background:var(--cf-surface); }
.page-btn:disabled { opacity:0.5; cursor:not-allowed; }
.page-btn--active { background:rgb(var(--primary)); border-color:rgb(var(--primary)); color:#fff; }
.page-btn--nav { width:34px; display:inline-flex; align-items:center; justify-content:center; }

/* Transitions */
.modal-fade-enter-active, .modal-fade-leave-active { transition:opacity 0.25s ease; }
.modal-fade-enter-from, .modal-fade-leave-to { opacity:0; }
.modal-slide-enter-active, .modal-slide-leave-active { transition:all 0.25s ease; }
.modal-slide-enter-from, .modal-slide-leave-to { opacity:0; transform:translateY(-16px); }

.doc-scroll::-webkit-scrollbar { width:6px; height:6px; }
.doc-scroll::-webkit-scrollbar-thumb { background:#cbd5e1; border-radius:3px; }

@media (max-width:768px) { .cf-dialog--xxl { max-width:100%; } .doc-scroll { max-height:64vh; } }
</style>
